import businessClient from 'src/services/clients/business'

import { IMeta, ILocation, ISetLocation } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '', endpoint: '' } }
const ILocationsResponse = { meta: IMeta, data: { list: [ILocation] } }
const ISetLocationResponse = { meta: IMeta, data: { update: [ISetLocation] } }

export const integrationEposNow = {
  /**
   * @return {Promise<IResponse>}
   */
  pairSystem(data, signal) {
    return businessClient().post('apppair/eposnow/pair/business', { data }, { signal })
  },

  /**
   * @return {Promise<ILocationsResponse>}
   */
  locationsList() {
    return businessClient().post('apppair/eposnow/location/portal/list', {})
  },

  /**
   * @param {{ store_id: number, api_key: string, api_secret: string, eposnow_store_name: string }} data
   * @return {Promise<ISetLocationResponse>}
   */
  pairStore(data) {
    return businessClient().post('apppair/eposnow/pair/store', { data })
  },

  /**
   * @return {Promise<IResponse>}
   */
  disconnect() {
    return businessClient().post('apppair/eposnow/disconnect', {})
  },

  /**
   * @return {Promise<IResponse>}
   */
  getCatalogue(filter) {
    return businessClient().post('apppair/eposnow/get-catalouge', { filter })
  },

  /**
   * @return {Promise<IResponse>}
   */
  fetchDevices() {
    return businessClient().post('apppair/eposnow/device', {})
  },

  /**
   * @return {Promise<IResponse>}
   */
  fetchStaff() {
    return businessClient().post('apppair/eposnow/staff', {})
  },
}
